import React from "react";
import Routes from "./Routes";

// Context
import { ProvideAuth } from "./context/useAuth";
import { ProvideDictionary } from "./context/useDictionary";
import { ProvideVisibility } from "./context/useVisibility";
import { BrowserRouter } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  return (
    <div className="main-container">
      <BrowserRouter>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
          <ProvideVisibility>
            <ProvideAuth>
              <ProvideDictionary>
                <Routes />
              </ProvideDictionary>
            </ProvideAuth>
          </ProvideVisibility>
        </GoogleOAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
